module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/zoom-a7293fe62e551d19e965b99f92211ead.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/zoom.svg
// module id = GwiX
// module chunks = 24